











import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ElementSignOutButton extends Vue {
  pending = false;

  async signOut() {
    // Keep email for analytics
    const email = this.$pdc.cognito!.user.username;

    try {
      // Set pending flag
      this.pending = true;
      // Sign out ...
      await this.$pdc.cognito!.signOut();
      // Analytics
      this.$pdc.analytics?.actions.trackSuccess('User SignedOut', {
        email,
      });
      // Redirect...
      await this.$router.push('/auth/sign-in');
    } catch (e) {
      // Analytics
      this.$pdc.analytics?.actions.trackFailure('User SignedOut', e, {
        email,
      });
      this.$sentry.captureException(e);
    } finally {
      // Reset 'pending' flag
      this.pending = false;

      this.$pdc.analytics?.actions.reset();
    }
  }
}
